import { DEVIATION_SETTING_PRIORITIES } from 'api/digitalTwin/digitalTwinConstants'
import { isHexColor } from 'utils/colorUtils'

export function applySystemDisplayColors(
  builtInPriorities: SystemSettingPriorityLevel[],
  systemPriorityLevels: SystemSettingPriorityLevel[] | null | undefined
): SystemSettingPriorityLevel[] {
  return builtInPriorities.map((priority) => {
    const displayColor = systemPriorityLevels?.find(
      (systemPriority) =>
        systemPriority.priority_level === priority.priority_level && isHexColor(systemPriority.display_color)
    )?.display_color
    return displayColor ? { ...priority, display_color: displayColor } : priority
  })
}

export function getDeviationSettingPriorities(
  systemPriorityLevels: SystemSettingPriorityLevel[] | null | undefined
): SystemSettingPriorityLevel[] {
  return [
    ...applySystemDisplayColors(DEVIATION_SETTING_PRIORITIES, systemPriorityLevels),
    ...(systemPriorityLevels ?? []),
  ]
}

/** A system level that Deviation settings lists beside Unplanned and Planned: on by default and not hidden. */
export function isDefaultSystemLevel(level: SystemSettingPriorityLevel): boolean {
  return (
    level.is_default === true &&
    level.is_hidden !== true &&
    !DEVIATION_SETTING_PRIORITIES.some((builtIn) => builtIn.priority_level === level.priority_level)
  )
}

/** What Deviation settings lists: Unplanned and Planned, plus the system's default levels that are not hidden. */
export function getDeviationModulePriorities(
  systemPriorityLevels: SystemSettingPriorityLevel[] | null | undefined
): SystemSettingPriorityLevel[] {
  const defaultSystemLevels = (systemPriorityLevels ?? []).filter(isDefaultSystemLevel)
  return [...applySystemDisplayColors(DEVIATION_SETTING_PRIORITIES, systemPriorityLevels), ...defaultSystemLevels]
}
